<template>
  <v-container>
    <v-menu>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              mdi-dots-vertical
            </v-icon>
          </template>
          <span>Acciones</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="selectComponent(item)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog max-width="50%" v-model="dialog">
      <v-card v-if="selectedComponent === 'ModificarPerfil'">
        <ModificarPerfil :item="item" />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModificarPerfil from "./ModificarPerfil.vue";
import { mapActions } from "vuex";
export default {
  props: ["item"],
  components: {
    ModificarPerfil,
  },
  data() {
    return {
      dialog: false,
      items: [
        {
          title: "Modificar Perfil",
          component: "ModificarPerfil",
        },
      ],
      selectedComponent: null,
    };
  },
  methods: {
    selectComponent(item) {
      if (item.component) {
        this.selectedComponent = item.component;
        this.dialog = true;
      }
    },
    ...mapActions(["setPerfil"]),
    openPerfil(perfil) {
      this.setPerfil(perfil);
      this.$emit("openPerfil"); // Emit an event to the parent component
    },
  },
};
</script>
